export default __webpack_public_path__ + "media/images/apartment_page/luxurious_bed-288bd79d6ee14fc9b86a8ae5db278dea.jpg";